module.exports = __webpack_public_path__ + "static/media/star-4.04c2f614.svg";